import { render, staticRenderFns } from "./SearchPointSelector.vue?vue&type=template&id=66551770&scoped=true"
import script from "./SearchPointSelector.vue?vue&type=script&lang=js"
export * from "./SearchPointSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66551770",
  null
  
)

export default component.exports